import { QueryClient } from "@tanstack/react-query";

// One client for the app. Defaults err on the side of "fresh enough":
// - 30s stale so operators see recent data without hammering the API
// - a few retries on transient errors, none on 4xx (handled in api.ts)
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
